import { render, staticRenderFns } from "./ReportalShow.vue?vue&type=template&id=1763645a&scoped=true&"
import script from "./ReportalShow.vue?vue&type=script&lang=js&"
export * from "./ReportalShow.vue?vue&type=script&lang=js&"
import style0 from "./ReportalShow.vue?vue&type=style&index=0&id=1763645a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1763645a",
  null
  
)

export default component.exports